import { PlanOffer } from '../translations-types';

const translations: PlanOffer = {
  question: 'Would you like to continue with {plan} next year?',
  yes: 'Yes, please',
  no: 'No, thanks',
  thanksYes: 'Thank you! You will receive the questionnaire by email shortly.',
  thanksNo: 'Thank you for your response.',
  alreadyRespondedYes: 'You already responded "yes". You will receive the questionnaire by email.',
  alreadyRespondedNo: 'You already responded "no".',
  error: 'Something went wrong. Please try again later.',
};

export default translations;
